import chartsAndMaps from './charts-and-maps'
import components from './components'
import formTable from './formTable'

export default [...components, ...formTable, ...chartsAndMaps]
